import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import store from './store'
import axios from 'axios';

Vue.config.productionTip = false

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

// Browser erlauben Sprachausgabe erst nach einer Berührung der Seite. Wird die App z.B. per Icon
// geöffnet, wartet der Text, bis der Nutzer das erste Mal tippt/klickt, und wird dann vorgelesen.
let pendingSpeech = null
const speakNow = function(text) {
  try {
    window.speechSynthesis.cancel()
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'de-DE';
    window.speechSynthesis.speak(utterance);
  } catch (error) {
    console.error("Fehler bei der globalen Sprachausgabe:", error);
  }
}
const flushPendingSpeech = function() {
  if (!pendingSpeech) return
  const text = pendingSpeech
  pendingSpeech = null
  speakNow(text)
}
;['pointerdown', 'touchend', 'keydown', 'click'].forEach(evt =>
  window.addEventListener(evt, flushPendingSpeech, { passive: true })
)

Vue.prototype.$speak = function(text) {
  if (!text) return
  const activated = navigator.userActivation ? navigator.userActivation.hasBeenActive : true
  if (activated) {
    speakNow(text)
  } else {
    pendingSpeech = text
  }
}

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')

